import { create } from 'zustand';
import { useNotificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { AccountsApi, RequestStrategyEnum, type AddAccountRequest } from '@shared/api';
import { Constants } from '@shared/widgets';

interface UseAddAccountStore {
  loading: boolean;
  error: string | null;
  success: boolean | null;
  addAccount: (request: AddAccountRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useAddAccountStore = create<UseAddAccountStore>((set) => ({
  loading: false,
  success: false,
  error: null,

  addAccount: ApiUtils.wrapperApi(async (request) => {
    try {
      set({ loading: true, success: null, error: null });
      await AccountsApi.addAccount(request);
      set({ loading: false, success: true });
      useNotificationStore.getState().setSuccess(Constants.DEFAULT_SUCCESS_MESSAGE);
    } catch (error) {
      set({ loading: false, success: null, error: ApiUtils.getApiError(error) });
      useNotificationStore.getState().setError(Constants.DEFAULT_ERROR_MESSAGE);
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, success: false, error: null }),
}));
